(function () {
	angular
		.module('trackeye')
		.factory('ModalService', ModalService);

	ModalService.$inject = ['Modal', '$rootScope', '$document', '$http', '$templateCache', '$compile'];

	function ModalService(Modal) {
		var exports = {};

		exports.create = function(template, data) {
			return new Modal(template, data);
		};

		return exports;
	}
})();